import SecondaryWalletTypeGeneralSettings from "@/models/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletTypeGeneralSettings";

export default class CreateSecondaryWalletTypeRequest {
    generalSettings: SecondaryWalletTypeGeneralSettings = new SecondaryWalletTypeGeneralSettings();
}